import { Amount } from "@ssc-booking/api-contracts"
import * as O from "fp-ts/Option"
import { ReactElement } from "react"

export type ReceiptRowBullet = {
    _type: "bullet"
    label: string
    isPromotional: boolean
    amount: O.Option<Amount>
    note?: string | JSX.Element
    rows: readonly ReceiptRowPax[]
}

export type ReceiptRowPax = Omit<ReceiptRowBullet, "_type" | "rows" | "note"> & {
    _type: "pax"
}

export type ReceiptRowDataLabel = {
    _type: "label"
    label: string
}

export type ReceiptRow = ReceiptRowBullet | ReceiptRowPax

export type ReceiptSection = {
    label: string | ReactElement
    key: string
    totalAmount: O.Option<Amount>
    note?: string | JSX.Element
    isPromotional: boolean
    rows: readonly ReceiptRow[]
}

export type ReceiptSectionWithLabel = Omit<ReceiptSection, "rows"> & {
    rows: readonly ReceiptRow[] | readonly ReceiptRowDataLabel[]
}

export const bulletRow = (props: Omit<ReceiptRowBullet, "_type">): ReceiptRowBullet => ({ ...props, _type: "bullet" })
export const isBulletRow = (row: ReceiptRow | ReceiptRowDataLabel): row is ReceiptRowBullet => row._type === "bullet"

export const paxRow = (props: Omit<ReceiptRowPax, "_type">): ReceiptRowPax => ({ ...props, _type: "pax" })
export const isPaxRow = (row: ReceiptRow | ReceiptRowDataLabel): row is ReceiptRowPax => row._type === "pax"

export const labelRow = (label: string): ReceiptRowDataLabel => ({ _type: "label", label })
export const isLabelRow = (row: ReceiptRow | ReceiptRowDataLabel): row is ReceiptRowDataLabel => row._type === "label"
